import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {SnackbarComponent} from '../snackbar/snackbar.component';

class Data {
  id: number=0;
  name: string='';

}
@Component({
  selector: 'app-subjects',
  templateUrl: './subjects.component.html',
  styleUrls: ['./subjects.component.css'],
  providers: [HelperService] 
})

export class SubjectsComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
	localStorage.removeItem('access_token');
	localStorage.removeItem('navigateroute');
  }
  @ViewChild(DataTableDirective)
  @ViewChild("fileInput") fileInput;
   @ViewChild("fileInput2") fileInput2;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas: Data[] = [];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;
  icon=this.helper.add_icon;
  icon_action='addClick';
  all:any=[];
  selected:any=[];
  grade_id=0;
  subject_name='';
  subject_icon='';
  subject_id='';
  download_link;
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router) {

  }

  ngOnInit() {
     this.download_link=this.helper.base_url;

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/subjects',{ headers: this.headers })
      .map(this.extractData)
      .subscribe(data => {
        this.datas = data;
        
          this.dtTrigger.next();
        
       
      });
  }
  editClick(id,name,icon){
    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.subject_name=name;
    this.subject_icon=this.helper.base_url+'storage/app/'+icon;
    this.subject_id=id;
  }

  
  addClick(e){
    this.http.get(this.helper.base_url+'http/get/subjects',{ headers: this.headers })
      .subscribe(
         
          (data) => {
          
            //console.log(data);
            // this.refresh();
          }, //For Success Response
          err => {console.error(err)} //For Error Response
      );
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  deleteClick(id){
  
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
      //this.snackbar.open('Are you sure!', 'Delete', {
        duration: 3000,
        extraClasses:  ['warning-snackbar'],
      }).onAction().subscribe(() => {
        this.http.get(this.helper.base_url+'http/delete/subjects/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) => this.refresh(false,'Subject Removed successfully'), //For Success Response
          err => {console.error(err)} //For Error Response
      );   
      });
  }


 refresh(val=false,msg=''){
   
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["subjects/"]));
      
 }
 add_form(addForm: NgForm){
  let body = new FormData();
  let fi = this.fileInput.nativeElement;
  body.append('name', addForm.value.name);
  
  body.append('file', fi.files[0]);

   this.http.post(this.helper.base_url+'http/add/subjects', body,{ headers: this.headers })
   .subscribe(
     (res) => {
      this.listClick(null) ;
      this.refresh(false,'Subject added successfully') ;
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 update_form(updateForm: NgForm){
  let id =this.subject_id;
  let body = new FormData();
  let fi = this.fileInput2.nativeElement;
  body.append('name', updateForm.value.name);
  body.append('file', fi.files[0]);
 
  this.http.post(this.helper.base_url+'http/update/subject/'+id, body,{ headers: this.headers })
  .subscribe(
    (res) => {
     this.listClick(null) ;
     this.refresh(false,'Subject updated successfully') ;
    }, //For Success Response
     err => {console.error(err)} //For Error Response);
  );
}

  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }

}



// WEBPACK FOOTER //
// ./src/app/subjects/subjects.component.ts